<template>
    <div>
        <div v-if="dataList.length > 0" class="page-btns-box">
            <el-button v-if="$utils.have('/tdc/download/cardList')" type="primary" icon="el-icon-download" size="small"
                @click="download" :loading="downLoading">导出</el-button>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" size="small" stripe>
                <el-table-column label="终端" prop="terminal"></el-table-column>
                <el-table-column label="短链演出详情页pv" prop="pv"></el-table-column>
                <el-table-column label="短链演出详情页uv" prop="uv"></el-table-column>
                <el-table-column label="短链详情页停留时长" prop="duration"></el-table-column>
                <el-table-column label="短链演出购票按钮点击次数" prop="buyClickCount"></el-table-column>
                <el-table-column label="短链演出下单人数" prop="orderUserCount"></el-table-column>
                <el-table-column label="短链演出下单数" prop="orderCount"></el-table-column>
                <el-table-column label="短链演出下单金额" prop="orderUserAmountStr"></el-table-column>
                <el-table-column label="复购参演艺人人数" prop="repurchaseUserCount"></el-table-column>
				<el-table-column label="复购参演艺人订单数" prop="repurchaseOrderCount"></el-table-column>
                <el-table-column label="全部演出下单人数" prop="allUserCount"></el-table-column>
                <el-table-column label="全部演出下单订单数" prop="allCount"></el-table-column>
                <el-table-column label="全部演出下单金额" prop="allAmountStr"></el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import { downloadFileTmp } from '@/assets/js/commonApi.js';
export default {
    props: {
        shortUrl: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            dataList: [],
            downLoading: false
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            this.$request({
                url: "/tdc/cardList",
                method: "POST",
                params: {
                    shortUrl: this.shortUrl
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.dataList = result;
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
        },
        async download() {
            let filePath;
            this.downLoading = true;
            const res = await this.$request({
                url: '/tdc/download/cardList',
                method: 'post',
                params: { shortUrl: this.shortUrl }
            })
                .catch(err => {
                    this.$message({ message: err.message, type: 'error' });
                })
            const { state, msg, result } = res.data;
            if (state == 1 && result) {
                filePath = result.url;
            } else {
                return this.$message.error(msg || '下载失败');
            }

            await downloadFileTmp(filePath, `${this.shortUrl}下单数据.xlsx`);
            this.downLoading = false;
        },
    }
}
</script>
<style lang="scss" scoped></style>